/**
 * アダプタの生成。**3 分岐の唯一の場所**で、4 つ目の送信先が要るときはここに 1 行足す。
 *
 * 公開の登録 API（registerAdapter 等）は出さない — EP-8 のプラグイン面と同じく座席のまま。
 * 分析を自前で拡張したい導入者は、公開イベント（`viewer.on(...)`）を購読すればよい。
 */
import type { AnalyticsOptions } from '../../core/options';
import type { AnalyticsAdapter } from '../types';
import { BeaconAdapter } from './beacon';
import { DataLayerAdapter } from './data-layer';
import { GtagAdapter } from './gtag';

export function createAdapters(
  options: AnalyticsOptions,
  view: Window,
  apiBase: string | null,
): AnalyticsAdapter[] {
  const adapters: AnalyticsAdapter[] = [];
  // 自前収集は宛先が分かるときだけ（標準形でない source では userData/comments と同じく機能ごと無効）
  if (options.collect && apiBase !== null) adapters.push(new BeaconAdapter(view));
  if (options.gtag) adapters.push(new GtagAdapter(view));
  if (options.dataLayer) adapters.push(new DataLayerAdapter(view));
  return adapters;
}
